// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ordersList_wrapper__LmlZB {
  max-width: 350px;
  padding: 0; }

.ordersList_header__gB6QZ {
  margin: 10px 10px 0 10px; }
  .ordersList_header_title__EYrvZ {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.03em;
    margin-bottom: 20px; }
  .ordersList_header_listInput__yvYwF {
    margin-top: 10px; }

.ordersList_list__xFIFw {
  height: calc(100vh - 310px);
  margin-top: 20px;
  margin-left: 10px;
  margin-right: 4px;
  overflow-y: scroll; }
  .ordersList_list_empty__2Jnci {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--HightEmphasis);
    letter-spacing: 0.15px; }
  .ordersList_list_paginations__\\+DQCo {
    height: calc(100vh - 107px); }

.ordersList_list__xFIFw::-webkit-scrollbar {
  width: 8px;
  background-color: inherit; }

.ordersList_list__xFIFw::-webkit-scrollbar-thumb {
  background: var(--Gray88);
  border-radius: 20px; }

.ordersList_list__xFIFw::-webkit-scrollbar-track {
  background-color: inherit; }
`, "",{"version":3,"sources":["webpack://./src/pages/previewOrders/components/OrdersList/ordersList.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,UAAU,EAAA;;AAGZ;EACE,wBAAwB,EAAA;EACxB;ICIA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDJf,sBAAsB;IACtB,mBAAmB,EAAA;EAErB;IACE,gBAAgB,EAAA;;AAIpB;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB,EAAA;EAClB;ICYA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDZf,2BAA2B;IAC3B,sBAAsB,EAAA;EAExB;IACE,2BAA2B,EAAA;;AAI/B;EACE,UAAU;EACV,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB;EACzB,mBAAmB,EAAA;;AAGrB;EACE,yBAAyB,EAAA","sourcesContent":["@import 'src/styles/fonts';\n\n.wrapper {\n  max-width: 350px;\n  padding: 0;\n}\n\n.header {\n  margin: 10px 10px 0 10px;\n  &_title {\n    @include h3;\n    letter-spacing: 0.03em;\n    margin-bottom: 20px;\n  }\n  &_listInput {\n    margin-top: 10px;\n  }\n}\n\n.list {\n  height: calc(100vh - 310px);\n  margin-top: 20px;\n  margin-left: 10px;\n  margin-right: 4px;\n  overflow-y: scroll;\n  &_empty {\n    @include body1;\n    color: var(--HightEmphasis);\n    letter-spacing: 0.15px;\n  }\n  &_paginations {\n    height: calc(100vh - 107px);\n  }\n}\n\n.list::-webkit-scrollbar {\n  width: 8px;\n  background-color: inherit;\n}\n\n.list::-webkit-scrollbar-thumb {\n  background: var(--Gray88);\n  border-radius: 20px;\n}\n\n.list::-webkit-scrollbar-track {\n  background-color: inherit;\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ordersList_wrapper__LmlZB`,
	"header": `ordersList_header__gB6QZ`,
	"header_title": `ordersList_header_title__EYrvZ`,
	"header_listInput": `ordersList_header_listInput__yvYwF`,
	"list": `ordersList_list__xFIFw`,
	"list_empty": `ordersList_list_empty__2Jnci`,
	"list_paginations": `ordersList_list_paginations__+DQCo`
};
export default ___CSS_LOADER_EXPORT___;
